/*
 * Copyright © 2018-2025, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import React, { ReactElement } from "react";
import { Link } from "react-router-dom";
import {
  getStringFromEnumsOrReturn,
  petGenders,
  petSpecies,
  strings,
} from "../../common/Strings/Strings";
import { PetProfileTabs } from "../Pet/PetProfile/ClinicPetProfile";
import PetProfilePicture from "../../components/Pictures/Pet/PetProfilePicture";
import { Heart } from "../../common/Icons/Heart";
import Tooltip from "../../components/Tooltip";
import Tag, { TagType } from "../../components/Tag";
import { PetDetailsResponse } from "../../models/pet/PetDetailsResponse";

interface Props {
  clinicPetDetails: PetDetailsResponse;
  userPetDetails?: PetDetailsResponse;
  weight?: number;
}

const PetInfo = ({ clinicPetDetails, userPetDetails, weight }: Props): ReactElement => (
  <div className="flex space-x-3 items-center">
    <div style={{ width: "40px", height: "40px" }}>
      <PetProfilePicture
        petId={userPetDetails?.id}
        species={clinicPetDetails?.species}
      />
    </div>
    <div>
      <div className="flex items-center">
        <Link
          to={`/clinic-pet-profile/${clinicPetDetails?.id}/${PetProfileTabs.basic}`}
        >
          {clinicPetDetails?.name}
        </Link>
        {clinicPetDetails?.deceased && (
          <div>
            <Tooltip content={strings.deceased}>
              <Heart className="ml-2" variant="solid" />
            </Tooltip>
          </div>
        )}
      </div>
      <div>
        {clinicPetDetails?.species &&
          petSpecies[clinicPetDetails?.species]}
        ,{" "}
        {clinicPetDetails?.gender &&
          petGenders[clinicPetDetails?.gender]}
        {clinicPetDetails?.color && `, ${clinicPetDetails?.color}`},{" "}
        {clinicPetDetails?.breed}
        {weight || clinicPetDetails?.lastMedicalRecordWeight
          ? `, ${weight || clinicPetDetails?.lastMedicalRecordWeight} kg`
          : ""}
      </div>
      {clinicPetDetails?.chronicDiseases?.map((disease, index) => (
        <span className="mr-2 mb-2" key={index}>
          <Tag type={TagType.danger} text={getStringFromEnumsOrReturn(disease)} />
        </span>
      ))}
    </div>
  </div>
);

export default PetInfo;
